import { Modal } from 'flowbite-react';
import React from 'react';

export default function ViewImage({
  show,
  setShow,
  imageUrl,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  imageUrl: string;
}) {
  function onCloseModal() {
    setShow(false);
  }
  return (
    <Modal show={show} size='5xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full flex justify-center'>
          <img
            src={imageUrl}
            // className='h-28'
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
